<script>

import api from "../../../api";
import Swal from "sweetalert2";
import router from '../../../router';

export default {
  components: { },
  data() {
    return {
      email: '',
      password: '',
      loading: false
    };
  },
  computed: {
  },
  methods: {
    recoverPassword() {
    var self = this;
    if(this.email.match(/\S+@\S+\.\S+/))
    {
      self.loading = true;
      var data = {
        email: this.email,
      };
      api.post('/api/users/forgot-password', data)
      .then((response) => {
        self.loading = false;
        console.log(response);
        Swal.fire({
          title: "Enter code to proceed",
          input: "number",
          showCancelButton: true,
          confirmButtonText: "Login",
          showLoaderOnConfirm: true,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          preConfirm: code => {
            // eslint-disable-next-line no-unused-vars
            return new Promise(function(resolve, reject) {
              setTimeout(function() {
                data.code = code;
                api.post('/api/users/verify-code', data)
                .then((response) => {
                  console.log(response);
                  var user = response.data;
                  if(user)
                  {
                    Swal.fire({
                      title: "Enter new password",
                      input: "password",
                      showCancelButton: false,
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      confirmButtonColor: "#556ee6",
                      cancelButtonColor: "#f46a6a",
                      preConfirm: password => {
                        // eslint-disable-next-line no-unused-vars
                        return new Promise(function(resolve, reject) {
                          setTimeout(function() {
                            data.password = password;
                            api.post('/api/users/recover-password', data)
                            .then(() => {
                              Swal.fire("Password changed!", "Password changed Successfully!", "success");
                              resolve()
                              router.push('/login');
                            }, (error) => {
                              console.log(error);
                              Swal.fire("Invalid password!", "Please try again", "warning");
                            });
                          }, 1000);
                        });
                      },
                      allowOutsideClick: false
                    })

                    resolve()
                  }
                  else {
                    Swal.fire("Code not matched!", "Please try again", "warning");
                  }
                }, (error) => {
                  console.log(error);
                  Swal.fire("Code not matched!", "Please try again", "warning");
                });
              }, 1000);
            });
          },
          allowOutsideClick: false
        })
      }, (error) => {
        self.loading = false;
        console.log(error);
        Swal.fire("Email or Password not matched!", "Please try again", "warning");
      });
    
    }

      else
      {
        Swal.fire("Invalid Email!", "Enter your email again!", "warning");
      }
    }
  },
  watch: {
  },
  mounted() {
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo-dark.png" width="70%" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Reset Password</h4>
                        <p class="text-muted">Reset your password to Patient Link.</p>
                      </div>

                      <div class="p-2 mt-5">
                        <div
                          class="alert alert-success mb-4"
                          role="alert"
                        >Enter your Email and instructions will be sent to you!</div>
                        <!-- <form class="form-horizontal" v-on:submit="sendEmail()"> -->
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">Email</label>
                            <input
                              type="email"
                              class="form-control"
                              id="useremail"
                              v-model="email"
                              placeholder="Enter email"
                            />
                          </div>

                          <div v-if="loading" class="mt-4 text-center">
                            <div class="spinner-border text-info" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>                     
                          
                          <div v-else class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              v-on:click="recoverPassword()"
                            >Reset</button>
                          </div>


                        <!-- </form> -->
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          Don't have an account ?
                          <router-link tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                          >Log in</router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>